import { FC, Fragment, useState } from 'react';
import { ChevronDarkRightIcon, DashboardLayout, DialogWithActions } from 'Components';
import { useLocalization } from 'Hooks';
import { Box, Typography } from '@material-ui/core';
import { OnOnlineApplicationCardQueryItemModel } from 'Models';
import { colors, fontSizes, gutters } from 'Theme/Variables';
import './StudentCard.scss';
import iconProfile from '../../../Assets/Icons/icon-profile.svg';
import iconPeople from '../../../Assets/Icons/icon-people.svg';
import { useHistory } from 'react-router';
import {
  onOnlineApplicationRequest,
  storeCardTransactions,
  closeKycWarningDialog,
  closeHasPrivilegedCardDialog,
} from '../../../Stores/CardTransactions';
import { useDispatch, useSelector } from 'react-redux';
import { UserState, userStore } from '../../../Stores/User';
import { clearApplicationData, setActiveCard } from 'Stores/CardApplication';
import CardApplicationErrors from '../CartApplicationErrors';
import StudentCardComparisonDialog from './StudentCardComparisonDialog';
import { routePath } from 'Navigator/routes';

type CardApplicationItemProps = {
  checkAlreadyApplicationStatus: (event: OnOnlineApplicationCardQueryItemModel) => void;
  OnOnlineApplicationCardQueryItemModel: (event: OnOnlineApplicationCardQueryItemModel) => void;
};

const StudentCard: FC<CardApplicationItemProps> = ({ OnOnlineApplicationCardQueryItemModel }) => {
  const {
    web_card_application_title,
    web_card_application_desc,
    web_btn_okay,
    web_btn_vazgec,
    web_pc_istanbulcard_student_apply_page_popup_btn_continue,
    web_pc_istanbulcard_student_apply_page_popup_title,
    web_pc_istanbulcard_student_apply_page_popup_desc,
    web_cant_apply_this_card,
    web_cant_apply_popup_title,
    cant_apply_popup_title,
    web_active_application,
    web_card_already_exists,
    web_card_for_myself_info,
    web_card_relation_info,
  } = useLocalization();
  const history = useHistory<any>();
  const dispatch = useDispatch();
  const userData: UserState = useSelector(userStore);
  const currentItem = history?.location?.state?.item as OnOnlineApplicationCardQueryItemModel;
  const customerNumber = userData?.customerNumber;
  const sessionToken = userData?.sessionToken;
  const [isOpenComparisonDialog, setIsOpenComparisonDialog] = useState<boolean>(false);
  const [isOpenHasPrivilegedCardDialog, setIsOpenHasPrivilegedCardDialog] = useState<boolean>(false);

  const checkCardStatus = (Product: OnOnlineApplicationCardQueryItemModel, normalizePlusCard = true) => {
    const selectedType = history?.location?.state?.selectedType || 'plus';
    const normalizedProduct =
      normalizePlusCard && Product?.ProductCode === 'IKT_ORC' ? { ...Product, ProductCode: 'IKP_ORC' } : Product;

    dispatch(
      onOnlineApplicationRequest({
        request: {
          CustomerNumber: customerNumber,
          SessionToken: sessionToken,
          ProductCode: normalizedProduct?.ProductCode,
          // Uygunluk sorgusuna seçilen ürünün alt ürün kodu gönderilmeli; alan hiç
          // gönderilmezse backend başvuruyu reddediyor (ProductResult=0).
          SubProductCode: normalizedProduct?.SubProductCode ?? null,
        },
        product: normalizedProduct,
        selectedType,
      })
    );
  };

  const checkAlreadyApplicationStatus = (Product: OnOnlineApplicationCardQueryItemModel) => {
    checkCardStatus(Product);

    // TODO: Old code should be removed.
    // const alreadyData = customerCardApplicationList?.find((item) => {
    //   return item.ProductCode === Product.ProductCode;
    // });
    // if (alreadyData) {
    //   if (alreadyData?.ApprovalStatus === ApprovalStatusEnum.WAS_CREATED) {
    //     checkCardStatus(Product);
    //   }
    // } else {
    //   checkCardStatus(Product);
    // }
  };

  const applicationForMyself = () => {
    const studentCartTypes = ['IKT_ORC'];
    if (studentCartTypes.includes(currentItem?.ProductCode)) {
      // For student products, run the same online application check as list flow
      checkCardStatus(currentItem, false);
      return;
    }
    checkAlreadyApplicationStatus(currentItem);
  };

  const handleSelfApplicationClick = () => {
    const isStudentProduct = currentItem?.ProductCode === 'IKT_ORC';
    const isUnknownProduct = !currentItem?.ProductCode;

    if (isStudentProduct || isUnknownProduct) {
      setIsOpenComparisonDialog(true);
      return;
    }

    applicationForMyself();
  };

  const handleContinuePlus = () => {
    setIsOpenComparisonDialog(false);
    // Popup'tan "plus ile devam", direkt plus öğrenci başvurusuyla BİREBİR aynı olmalı:
    // standart öğrenci ürününü taklit etmek yerine (yanlış ShippingType taşıyıp IBM gösteriyor)
    // listedeki gerçek IKP_ORC ürününü kullan. Listede yoksa eski davranışa düş.
    const ikpOrcProduct = istanbulCardTypeList?.find((item) => item.ProductCode === 'IKP_ORC');
    const normalizedProduct =
      currentItem?.ProductCode === 'IKT_ORC' ? ikpOrcProduct || { ...currentItem, ProductCode: 'IKP_ORC' } : currentItem;
    dispatch(setActiveCard(normalizedProduct));
    checkCardStatus(normalizedProduct);
  };

  const handleContinueStudent = () => {
    setIsOpenComparisonDialog(false);
    // Standart öğrenci kartında bu sayfada RI.OnOnlineApplicationQuery ATMIYORUZ.
    // Sorgu ve kart durumu/adres kontrolleri bir sonraki adımda (Ürün Tipi adımı,
    // "Devam et") zaten atılıyor. Burada sadece aktif kartı set edip adımlara yönlendiriyoruz.
    const selectedType = history?.location?.state?.selectedType;
    dispatch(clearApplicationData({ withoutCard: true, withoutStep: true }));
    dispatch(setActiveCard(currentItem));
    history.push(routePath.cardApplicationSteps, {
      item: undefined,
      relationShipApply: false,
      selectedType,
    });
  };
  let { onOnlineApplicationCardStatusCode, isOpenKycWarningDialog, isOpenHasPrivilegedCardDialog: storeHasPrivilegedDialog, istanbulCardTypeList } =
    useSelector(storeCardTransactions);

  const handleContinueHasPrivilegedCard = () => {
    setIsOpenHasPrivilegedCardDialog(false);
    dispatch(closeHasPrivilegedCardDialog());

    if (currentItem) {
      const selectedType = history?.location?.state?.selectedType || 'plus';
      // Popup'tan "plus ile devam", direkt plus öğrenci başvurusuyla BİREBİR aynı olmalı:
      // standart öğrenci ürününü taklit etmek yerine (yanlış ShippingType taşıyıp IBM gösteriyor)
      // listedeki gerçek IKP_ORC ürününü kullan. Listede yoksa eski davranışa düş.
      const ikpOrcProduct = istanbulCardTypeList?.find((item) => item.ProductCode === 'IKP_ORC');
      const normalizedProduct =
        currentItem?.ProductCode === 'IKT_ORC' ? ikpOrcProduct || { ...currentItem, ProductCode: 'IKP_ORC' } : currentItem;

      dispatch(
        onOnlineApplicationRequest({
          request: {
            CustomerNumber: customerNumber,
            SessionToken: sessionToken,
            ProductCode: normalizedProduct?.ProductCode,
            SubProductCode: normalizedProduct?.SubProductCode ?? null,
          },
          product: normalizedProduct,
          bypassPrivilegedDialog: true,
          selectedType,
        })
      );
    }
  };

  const redirectToApp = () => {
    const iOS_ANDROID_LINK = 'https://istanbulkart.go.link?adj_t=1r9k32kh';
    const HUAWEI_LINK = 'https://appgallery.huawei.com/app/C102347171';

    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const isHuawei = /huawei|honor/i.test(navigator.userAgent);

    let linkToOpen;

    if (isMobile) {
      if (isHuawei) {
        linkToOpen = HUAWEI_LINK;
      } else {
        linkToOpen = iOS_ANDROID_LINK;
      }
    } else {
      linkToOpen = iOS_ANDROID_LINK;
    }

    window.open(linkToOpen, '_blank');
    dispatch(closeKycWarningDialog());
  };

  const cmsData: any = useLocalization();

  return (
    <DashboardLayout backButton>
      <Fragment>
        <CardApplicationErrors />

        <Typography variant="h3" align="center">
          <Box fontWeight={600}>{web_card_application_title}</Box>
        </Typography>
        <Typography variant="h3" align="center">
          <Box mb={gutters.big} color={colors.checkboxLabel} fontSize={fontSizes.regular} mt={gutters.small}>
            {web_card_application_desc}?
          </Box>
        </Typography>
        <div
          style={{ width: 500, marginLeft: 'auto', marginRight: 'auto' }}
          // key={applicationCard?.ProductName}
          // onClick={() => checkAlreadyApplicationStatus(currentItem)}
          onClick={handleSelfApplicationClick}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleSelfApplicationClick();
            }
          }}
          role="button"
          className="cardApplicationItem__item"
          itemID="applyCardBtnTest"
        >
          <div className="cardApplicationItem__item__first-row">
            <img className="showcase__img" src={iconProfile} alt="" />
            <Typography variant="h3">
              <Box
                style={{ textTransform: 'capitalize' }}
                ml={gutters.regular}
                fontSize={fontSizes.regular}
                fontWeight={600}
              >
                Kendim adına başvuracağım
              </Box>
              <Box
                style={{ textTransform: 'capitalize', marginRight: 120 }}
                ml={gutters.regular}
                fontSize={fontSizes.regular}
                fontWeight={300}
              >
                {web_card_for_myself_info}
              </Box>
            </Typography>
          </div>
          <ChevronDarkRightIcon />
        </div>
        <div
          style={{ width: 500, marginLeft: 'auto', marginRight: 'auto' }}
          // key={applicationCard?.ProductName}
          onClick={() => history.push('/card-info', { item: currentItem })}
          tabIndex={0}
          onKeyDown={(e) => {
            if(e.key === 'Enter' || e.key === ' '){
              e.preventDefault();
              history.push('/card-info', { item: currentItem })
            }
          }}
          role="button"
          className="cardApplicationItem__item"
          itemID="applyCardBtnTest"
        >
          <div className="cardApplicationItem__item__first-row">
            <img className="showcase__img" src={iconPeople} alt="" />
            <Typography variant="h3">
              <Box
                style={{ textTransform: 'capitalize' }}
                ml={gutters.regular}
                fontSize={fontSizes.regular}
                fontWeight={600}
              >
                Yakınım adına başvuracağım
              </Box>
              <Box
                style={{ textTransform: 'capitalize', marginRight: 120 }}
                ml={gutters.regular}
                fontSize={fontSizes.regular}
                fontWeight={300}
              >
                {web_card_relation_info}
              </Box>
            </Typography>
          </div>
          <ChevronDarkRightIcon />
        </div>
        <DialogWithActions
          alignTitle="left"
          primaryButton={{
            label: web_btn_okay,
            handleClick: () => {
              dispatch(closeKycWarningDialog());
            },
          }}
          open={isOpenKycWarningDialog}
          hide={() => {
            dispatch(closeKycWarningDialog());
          }}
          title={cant_apply_popup_title}
          text={cmsData[onOnlineApplicationCardStatusCode || 'Missing Key:' + 'onOnlineApplicationCardStatusCode']}
        />

        <StudentCardComparisonDialog
          open={isOpenComparisonDialog}
          onClose={() => setIsOpenComparisonDialog(false)}
          onCancel={() => history.push(`${routePath.cardApplication}?type=istanbulkart`)}
          onContinuePlus={handleContinuePlus}
          onContinueStudent={handleContinueStudent}
        />

        <DialogWithActions
          alignTitle="left"
          primaryButton={{
            label: web_pc_istanbulcard_student_apply_page_popup_btn_continue || 'Devam et',
            handleClick: handleContinueHasPrivilegedCard,
          }}
          secondaryButton={{ label: web_btn_vazgec, handleClick: () => dispatch(closeHasPrivilegedCardDialog()) }}
          open={isOpenHasPrivilegedCardDialog || storeHasPrivilegedDialog}
          hide={() => dispatch(closeHasPrivilegedCardDialog())}
          title={web_pc_istanbulcard_student_apply_page_popup_title}
          text={web_pc_istanbulcard_student_apply_page_popup_desc}
        />
      </Fragment>
    </DashboardLayout>
  );
};
export default StudentCard;
